/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
import LoginControl from './LoginControl';
export default LoginControl;